import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Config = new Config()
  public configSubject: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {
      if(window.location.origin.indexOf("4200")<0) {
          this.config.base_url = window.location.origin + "/";
          this.config.accounting_url=(window.location.origin + "/").replace(window.location.origin.split(":")[2],this.config.accounting_url);
      }
      this.configSubject.next(this.config);
  }
  public load() {
    return this.http.get('assets/config/config.json')
        .toPromise()
        .then((config: any) => {
          this.config = config;

          if(window.location.origin.indexOf("4200")<0) {
            this.config.base_url = window.location.origin + "/";
            this.config.accounting_url=(window.location.origin + "/").replace(window.location.origin.split(":")[2],this.config.accounting_url);
          }
          this.configSubject.next(this.config);
        })
        .catch((err: any) => {
          console.error('ERROR: ' + err);
        })
  }

  getBaseUrl() {
    return this.config.base_url;
  }
  getAccountingUrl() {
    return this.config.accounting_url;
  }

}
export class Config {
  base_url: string="http://localhost:9190/";
  // base_url: string="https://searchia.ir/";
  accounting_url:string="http://localhost:9190/";
  // accounting_url:string="https://searchia.ir/";
}
